import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface ClaimReasonResponseItem {
  reasonCode: string;
  reasonCodeDesc: string;
}

export const getClaimReasonAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.OVERCHARGE_CLAIM}/GetClaimReason`,
  });
};

export type ClaimReasonResponse = ClaimReasonResponseItem[];

export const fetchClaimReasonList = async (): Promise<ClaimReasonResponse> => {
  const response: AxiosResponse<ClaimReasonResponse> = await getClaimReasonAPI();
  return response.data;
};
